import React from 'react'
import { useTranslation } from 'react-i18next'

interface TooltipContentProps {
  translationKey: string
}

const TooltipContent = ({ translationKey }: TooltipContentProps) => {
  const { t } = useTranslation()
  return <> {t(translationKey)} </>
}

export default TooltipContent
